import { render, staticRenderFns } from "./customSelfExpense.vue?vue&type=template&id=76701040&scoped=true&"
import script from "./customSelfExpense.vue?vue&type=script&lang=ts&"
export * from "./customSelfExpense.vue?vue&type=script&lang=ts&"
import style0 from "./customSelfExpense.vue?vue&type=style&index=0&id=76701040&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76701040",
  null
  
)

export default component.exports